module.exports = __webpack_public_path__ + "static/media/image.abcc744e.svg";